module.exports = __webpack_public_path__ + "img/z222.prt.050b0ae4.jpg";